<template>
  <avtalat-modal :idealWidth="475" :idealHeight="240"
    ><div>
      <div>
        Du har inte ändrat i standardmeddelandet som skickas till kunden. Vill
        du fortsätta ändå?
      </div>
      <div class="mt-sm flex justify-evenly">
        <avtalat-button outlined @click="() => emit('cancel')"
          >Avbryt</avtalat-button
        >
        <avtalat-button @click="() => emit('submit')"
          >Fortsätt</avtalat-button
        >
      </div>
    </div></avtalat-modal
  >
</template>

<script setup lang="ts">
const emit = defineEmits(["submit", "cancel"]);
</script>
